import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, tap } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorHandlingService } from '../services/error-handling.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private errorHandlingSrvc = inject(ErrorHandlingService);
  private router = inject(Router);
  constructor() {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          //console.log('event--->>>', event);

          if (event.status) {
            switch (event.status) {
              case 200:
              case 201:
              case 204:
                return event;
              case 209:
                // call error service to handle 209 status
                this.errorHandlingSrvc.handleError(event);
                return event;
              default:
                return event;
            }
          }
          return event;
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.router.navigate(['/welcome']);
          return throwError(error);
        }
        //call the error service to handle the error
        this.errorHandlingSrvc.handleError(error);
        return throwError(error);
      })
    );
  }
}
